import React from "react";
import { Link } from "react-router-dom";
import teamAbout from "../assets/teamabout.jpg";
import { Check, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const AboutUs = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-200 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        {/* Top Centered Header */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 lg:mb-24"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-ink-900 font-display">
            About St. John <br /> Real Estate Specialists
          </h2>
        </motion.div>

        {/* Split Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {/* Left Content */}
          <motion.div 
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="flex flex-col"
          >
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-ink-900 leading-tight mb-6 font-display">
              Your trusted partner in finding exceptional properties.
            </h3>
            
            <p className="text-ink-600 text-lg mb-8 leading-relaxed font-light">
              We are a dedicated team of real estate professionals committed to helping you find your perfect property on the beautiful island of St. John. With over 15 years of experience in the local market, we understand the unique opportunities and challenges of island living.
            </p>

            <ul className="space-y-5 mb-10">
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <div className="mt-1 bg-ink-900/5 p-1 rounded">
                  <Check className="w-4 h-4 text-ink-900" />
                </div>
                <div>
                  <h4 className="font-semibold text-ink-900 mb-1">15+ Years Experience</h4>
                  <p className="text-ink-600 text-sm font-light">Deep expertise in St. John's unique real estate market and local dynamics.</p>
                </div>
              </motion.li>
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <div className="mt-1 bg-ink-900/5 p-1 rounded">
                  <Check className="w-4 h-4 text-ink-900" />
                </div>
                <div>
                  <h4 className="font-semibold text-ink-900 mb-1">Personalized Service</h4>
                  <p className="text-ink-600 text-sm font-light">We tailor our approach to match your unique needs and goals.</p>
                </div>
              </motion.li>
              <motion.li 
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <div className="mt-1 bg-ink-900/5 p-1 rounded">
                  <Check className="w-4 h-4 text-ink-900" />
                </div>
                <div>
                  <h4 className="font-semibold text-ink-900 mb-1">Market Experts</h4>
                  <p className="text-ink-600 text-sm font-light">Stay ahead with real-time market insights and property updates.</p>
                </div>
              </motion.li>
            </ul>

            <div>
              <Link 
                to="/properties"
                className="inline-flex px-8 py-4 bg-ink-900 text-white font-medium rounded-full hover:bg-ink-800 transition-transform hover:scale-105 duration-300 items-center gap-2 text-sm"
              >
                Explore Properties Now <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="aspect-[3/2] rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src={teamAbout} 
                alt="St. John Real Estate Team" 
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </motion.div>
          
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
